import { Button, Flex, Text } from '@chakra-ui/react'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ArrowDropDownRoundedIcon from '@material-ui/icons/ArrowDropDown'
import { useStoreState } from 'easy-peasy'
import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

export function ReportsNav() {
  const location = useLocation()
  const history = useHistory()
  const [anchorEl, setAnchorEl] = useState(null)
  const { user_role } = useStoreState(state => state.auth.user)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleMenuItemClick = path => () => {
    history.push(path)
    handleMenuClose()
  }

  return (
    <>
      <Button
        onClick={handleClick}
        sx={{ backgroundColor: 'transparent', width: 150 }}
        id="insights-menu-toggle"
        data-click-text="Reports"
      >
        <Flex sx={{ justifyContent: 'center', alignItems: 'center' }}>
          <Text
            sx={{
              color: user_role !== 'admin' ? 'white' : 'primary',
              fontWeight: 'normal',
              fontSize: '16px'
            }}
          >
            Reports
          </Text>
          <ArrowDropDownRoundedIcon
            fontSize="large"
            fill={user_role !== 'admin' ? 'white' : 'primary'}
          />
        </Flex>
      </Button>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <MenuItem
          selected={location.pathname.includes('/insights/utilization')}
          onClick={handleMenuItemClick('/insights/utilization')}
        >
          <span>Utilization</span>
        </MenuItem>
      </Menu>
    </>
  )
}
